<template>
  <div class="marketingProjectManagement">
		<iframe
			v-show="show"
			class="my_iframe"
			id="fram"
			width="100%"
			height="100%"
			:src="iframeUrl"
			frameborder="0"
		></iframe>
    <div class="realTaskAll" v-show="isShowCenter">
       <realTaskmenu v-on:cut="cut"></realTaskmenu>
      <div class="content">
        <div v-if="this.$store.state.cutNum == 1" style="height: 100%">
          <classCompany :classCompany="classCompany" @name="myfuntion()" @jumpMgy="jumpMgy"></classCompany>
        </div>
        <div v-else-if="this.$store.state.cutNum == 2" style="height:100%">
          <marketProjectReview
            :marketProjectReview="marketProjectReview"
             @name="myfuntion()"
          ></marketProjectReview>
        </div>
      </div>
    </div>
		<!-- 右侧栏 -->
		<div class="right_wrap" v-if="showRight">
			<div class="showBtn" @click="showHidden">
				<img src="/static/images/newRealTask/show.png" />
			</div>
			<div class="right_cont" v-show="rightShow">
				<div class="header_top">
					<h3>资料箱</h3>
					<img @click="goback" src="/static/images/newRealTask/back.png" />
				</div>
				<div class="project-list">
					<div class="project-item">
						<div class="top">
							<img src="/static/images/newRealTask/picon.png" />
							<span>东航项目包-2021</span>
						</div>
						<div class="project-cont">
							<el-tree
								ref="ptree"
							  :data="treeData"
							  :props="defaultProps"
								:default-expand-all="true"
							  @node-click="handleNodeClick">
							</el-tree>
						</div>
					</div>
				</div>
			</div>
		</div>
		
  </div>
</template>

<script>
import newRealyObjectHeader from "./components/newRealyObjectHeader";
import classCompany from "./components/classCompany";
import marketProjectReview from "./components/marketProjectReview";
import realTaskmenu from "./components/realTaskMenu";
import crypto from 'crypto'
import axios from 'axios'
import qs from 'qs'
import * as api from "../../api/marketingProjectManagement";
export default {
  data() {
    return {
      cut_result: 1,
      marketProjectReview: [],
      classCompany: [],
      params: {},
      returnParameters:-1,
			iframeUrl: '',
			show: false,
			isShowCenter: true,
			rightShow: false,
			myIframeStyle: {
			  width: '65%',
			  height: '100%',
			},
			showRight: false,
			treeData: [{
          label: '一级 1',
          children: [{
            label: '二级 1-1',
            children: [{
              label: '三级 1-1-1'
            }]
          }]
        }, {
          label: '一级 2',
          children: [{
            label: '二级 2-1',
            children: [{
              label: '三级 2-1-1'
            }]
          }, {
            label: '二级 2-2',
            children: [{
              label: '三级 2-2-1'
            }]
          }]
        }, {
          label: '一级 3',
          children: [{
            label: '二级 3-1',
            children: [{
              label: '三级 3-1-1'
            }]
          }, {
            label: '二级 3-2',
            children: [{
              label: '三级 3-2-1'
            }]
          }]
        }],
				defaultProps: {
					children: 'children',
					label: 'label'
				}
    };
  },
  created() {},
  methods: {
    cut(val) {
      this.$store.state.cutNum = val;
    },
    myfuntion(val){
			this.returnParameters = val
    },
		jumpMgy(val) {
			let that = this
			let userType = sessionStorage.getItem('userType') == 2 ? 2 : 1
			let phone = sessionStorage.getItem('mobile')
			let time = new Date().getTime() + ""
			let userId = sessionStorage.getItem('userId')
			let examType = '6'
			let model = "zsrw"
			let nickName = sessionStorage.getItem("loginName")
			let classId = val.id
			let className = val.companyName
			let projetPackage = this.getTeamMsg(classId)
			let url = 'classId=' + classId + '&className=' + className + '&courseId=&courseName=&examType=6&mobile=' +
				phone + '&model=zsrw&nickName=' + nickName + '&platform=&projetPackage=' + projetPackage +
				'&questionId=&roles=&schoolId=&schoolName=&teamId=&teamName=&templateCode=&time=' + time + '&userId=' +
				userId + '&userType=' + userType
			let sha1sign = this.setSha1(url)
			let mgyObj = {
				classId: classId,
				className: className,
				courseId: '',
				courseName: '',
				examType: examType,
				mobile: phone,
				model: model,
				nickName: nickName,
				platform: '',
				schoolId: '',
				schoolName: '',
				templateCode: '',
				time: time,
				userId: userId,
				projetPackage: that.getTeamMsg(val.id),
				questionId: '',
				roles: '',
				teamId: '',
				teamName: '',
				userType: userType,
				sign: sha1sign
			}
		
			axios.post(process.env.MGYZSRW_API, qs.stringify(mgyObj)).then(res => {
				if (res.data.result) {
					this.iframeUrl = res.data.value
					this.show = true
					this.isShowCenter = false
					this.rightShow = true
					this.showRight = true
					this.getProjectTree(val.id)
				} else {
					this.$messageError(res.data.error.message)
				}
			})
		},
		getProjectTree(id){
			api.getProjectTree(id).then(res=>{
				console.log(res)
			})
		},
		setSha1(url) { //sha1加密
			const hmac = crypto.createHmac('sha1', '123456');
			hmac.update(url);
			return hmac.digest('hex')
		},
		getTeamMsg(id) {
			let newArr = []
			api.getTeamMsg(id).then(res => {
				if (res.code == 0) {
					let arr = res.data.list
					arr.forEach(item => {
						let obj = {}
						obj.id = item.projectId
						obj.projectName = item.projectName
						newArr.push(obj)
					})
				} else {
					this.$messageError(res.msg)
				}
			})
			return newArr
		},
		goback(){
			this.iframeUrl = ''
			this.isShowCenter = true
			this.show = false
			this.showRight = false
		},
		showHidden(){
			this.rightShow = !this.rightShow
			if(this.rightShow){
				$(".right_wrap").css({width: "317px", height: "95%"});
				$(".right_cont").css({width: "301px", height: "100%"});
			}else{
				$(".right_wrap").css({width: "15px", height: "95%"});
				$(".right_cont").css({width: "0", height: "100%"});
			}
		},
		handleNodeClick(data) {
			console.log(data);
		}
  },
  components: {
    classCompany,
    marketProjectReview,
    newRealyObjectHeader,
    realTaskmenu,
  },
};
</script>

<style lang="scss">
.marketingProjectManagement {
  width: 100%;
  height: 100%;
  background: #f5f5f7;
  .realTaskAll {
    background: #f5f5f7;
    padding: 20px;
    display: flex;
    height: calc(100% - 90px);
        justify-content: center;
  }
  .content {
    background: #f9f9fa;
    height: 100%;
    width: 1062px;
    margin-left: 20px;
  }
	.right_wrap {
		display: flex;
		justify-content: space-around;
		align-items: center;
		position: absolute;
		right: 0;
		top: 50px;
		width: 314px;
		height: 95%;
		z-index: 999;
		
		.showBtn {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 12px;
			height: 34px;
			background: #F5F5F7;
			box-shadow: -2px 0px 4px 0px rgba(206,205,205,0.31);
			border-radius: 4px 0px 0px 4px;
			img {
				display: inline-block;
				width: 7px;
				height: 9px;
			}
		}
		.right_cont {
			width: 301px;
			height: 100%;
			background: #FFFFFF;
			box-shadow: 0px 3px 8px 0px rgba(234,223,223,0.5);
			transition: all 0.3s;
			.header_top {
				height: 36px;
				background-color: #F4F4F4;
				padding: 0 15px;
				box-sizing: border-box;
				display: flex;
				justify-content: space-between;
				align-items: center;
				h3 {
					font-size: 14px;
					font-weight: 500;
					color: #303133;
				}
				img {
					display: inline-block;
					width: 32px;
					height: 17px;
					cursor: pointer;
				}
			}
			
			.project-list {
				margin-top: 18px;
				padding: 0 15px;
				.project-item {
					width: 271px;
					.top {
						height: 36px;
						background: #F8F8F8;
						display: flex;
						justify-content: flex-start;
						align-items: center;
						font-size: 12px;
						color: #303133;
						img {
							display: inline-block;
							width: 14px;
							height: 14px;
							margin-left: 14px;
							margin-right: 5px;
						}
					}
					.project-cont {
						min-height: 30px;
						background-color: #F2F2F2;
						padding: 10px 0;
						box-sizing: border-box;
						.el-tree {
							.el-tree-node__content {
								height: 30px;
							}
						}
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/newRealTask/marketingProjectManagement.vue